/* @flow */

import React from 'react';
import glamorous from 'glamorous';
import { padding } from 'polished';

type Props = {
  children: any,
  title: string,
};

const StyledCell = glamorous.span(({ theme }) => ({
  textTransform: 'uppercase',
  borderColor: 'rgba(100, 100, 100, 0.25)',
  borderTopWidth: 0,
  borderRightWidth: 0,
  borderBottomWidth: 1,
  borderLeftWidth: 0,
  display: 'flex',
  justifyContent: 'space-between',
  // $FlowIgnore
  ...padding(theme.spacing.xsmall, 0),
  '&:not(:last-child)': {
    borderStyle: 'solid',
  },
}));

const Title = glamorous.span({
  display: 'flex',
});

const Data = glamorous.span({
  display: 'flex',
  whiteSpace: 'nowrap',
});

function Cell({ children, title }: Props) {
  return (
    <StyledCell>
      <Title>{title}</Title>
      <Data>{children}</Data>
    </StyledCell>
  );
}

export default Cell;
